export default function isNonEmptyString(value: unknown): value is string {
  if (typeof value != 'string') {
    return false;
  }

  return Boolean(value);
}
